import Vue from 'vue'
import Lodash from 'lodash'
import Decimal from 'decimal.js'
import CryptoJS from 'crypto-js';
import * as XLSX from 'xlsx'
import axios from '@/api/axios'
import router from '@/router/index.js';
// 解决计算精度
function $D(...args) {
  // conf.op 的type有: add(加) sub(减) mul(乘) div(除)
  try {
    let defaultConf = {op: 'add', fixed: 2}
    let conf = Object.prototype.toString.call(args[args.length - 1]) === '[object Object]' ? Lodash.merge(defaultConf, args[args.length - 1]) : defaultConf
    if (Object.prototype.toString.call(args[args.length - 1]) === '[object Object]') args.pop()

    let notPass = args.some(x => {
      if (x === '' || x === null || isNaN(Number(x))) {
        return true
      }
    })
    if (notPass) {
      return null
    }
    let ret = new Decimal(args[0])
    for (let i = 1; i < args.length; i++) {
      ret = ret[conf.op](args[i])
    }
    return Lodash.round(ret, conf.fixed)
  } catch (error) {
    console.log(error);
  }
}
Vue.prototype.$D = $D
Vue.prototype.Decimal = Decimal


// 单位转换，micrometer: 是否千分符处理  isObject: 是否以对象的形式返回结果  defaultVal 决定为假值时的返回结果  precision: 小数精度 fixedUnit: 仅支持传入w 固定以万为单位处理
function fmt(value, options = {}){
  if(isNaN(value)){return value}
  let opts = Object.assign({micrometer: false, isObject: false, defaultVal: '', precision: 2, fixedUnit: '', isEng: false}, options)
  if(['undefined', undefined, 'null', null, ''].includes(value)){return opts.defaultVal}
  let unit = ''
  let result = 0
  if (opts.fixedUnit.indexOf("万") > -1) { // 固定单位处理
    result = $D(value * 1, 10000, {op: 'div'})
  } else if (opts.fixedUnit.indexOf("亿") > -1) { // 固定单位处理
    result = $D(value * 1, 100000000, {op: 'div'})
  } else {
    if (Math.abs(value) < 10000) {
      result = +value
    }else if(Math.abs(value) < 100000000){
      unit = opts.isEng ? 'w' : '万'
      result = $D(value * 1, 10000, {op: 'div'})
    }else{
      unit = '亿'
      result = $D(value * 1, 100000000, {op: 'div'})
    }
  }
  result = Lodash.round(result, opts.precision)
  if(opts.micrometer){
    result = (+result).toLocaleString()
  }
  return opts.isObject ? {value: result, unit} : `${result}${unit}`
}

Vue.prototype.fmt = fmt

// 数组数据（通常用于表格）千分符处理
Vue.prototype.formatTable = (list, params) => {
  let {after, excludes = [], page, limit} = params || {}
  // excludes  排除的属性
  if(!(list instanceof Array)){return []}
  return list.map((x, i) => {
    let sourceData = {}
    for (const key in x) {
      if (excludes.includes(key) || isNaN(x[key])) { continue }  // 排除的字段
      if (/.*rate$/.test(key)) {  // 以rate结尾
        sourceData[key] = x[key]
        x[key] = fmt(x[key], {micrometer: true, isObject: true})?.value + '%'
      }else if (/.*[id|Id|ID]$/.test(key)) {  // 以id结尾
      } else {
        sourceData[key] = x[key]
        x[key] = fmt(x[key], {micrometer: true})
      }
    }
    x.sourceData = sourceData
    if (after) {
      x = after(x, i) || x
    }
    if (page !== undefined && limit !== undefined) {
      x.frontOrder = (i + 1) + (page - 1) * limit
    }
    return x
  })
}


class Calculate extends Decimal {
  constructor(value, isNull) {
    super(value)
    this.isNull = isNull
  }
  end(precision = 2) {
    return this.isNull ? null : Lodash.round(+this, precision)
  }
  add(value) {    // isNaN([]): false
    if (value === '' || value === null || isNaN(value) || value instanceof Array || this.isNull) {
      this.isNull = true
      return this
    } else {
      return new Calculate(super.add(value))
    }
  }
  sub(value) {
    if (value === '' || value === null || isNaN(value) || value instanceof Array || this.isNull) {
      this.isNull = true
      return this
    } else {
      return new Calculate(super.sub(value))
    }
  }
  mul(value) {
    if (value === '' || value === null || isNaN(value) || value instanceof Array || this.isNull) {
      this.isNull = true
      return this
    } else {
      return new Calculate(super.mul(value))
    }
  }
  div(value) {
    if (+value === 0 || value === '' || value === null || isNaN(value) || value instanceof Array || this.isNull) {
      this.isNull = true
      return this
    } else {
      return new Calculate(super.div(value))
    }
  }
}
function calc(value) {
  if (value === '' || value === null || isNaN(value)) {
    return new Calculate(0, true) // 若初始值也为无效值，则进行初始值无效标记，并返回一个有效的Decimal实例以进行链式调用
  }
  return new Calculate(value)
}
Vue.prototype.$calc = calc  // 链式调用中只要出现一个无效值，其最终结果都会返回null，最后可通过调用end以获取正确的数值结果

Vue.prototype.$utils={
  fileSignature(fileId){
    // 后端要秒级时间戳
    const timestamp= Math.floor(Date.now() / 1000);
    const token=localStorage.getItem('api_token')
    const uid=localStorage.getItem('uid')
    return {
      timestamp,
      signature: CryptoJS.MD5(`1scv6zfzSR1wLaWN${timestamp}${fileId}${token}${uid}`).toString()
    }
  },
    // 打开其他子系统页面
  async openOtherSystem(config){
    // sys 系统名称 ，path 指定页面的相对路径目前只有数据看板加了对jumpPath参数的解析
    const { sys, path } = config
    const type = process.env.NODE_ENV === 'development' || location.href.includes('test.') ? '测试线' : '正式线'
    const urlMap = {
      '集团数据看板-测试线':'http://test.cl.changwankeji.com:8080/index.html#/token?loginStr=<loginStr>',
      '集团数据看板-正式线':'http://dm.changwankeji.com:8189/index.html#/token?loginStr=<loginStr>',
      // '观星-测试线':'http://guanxing.changwankeji.com/?sid=<loginStr>',
      // '观星-正式线':'http://guanxing.changwankeji.com/?sid=<loginStr>',
    }
    const url = urlMap[`${sys}-${type}`]
    if(!url) {
      this.$modal.message({status: 'error', content: `${sys}系统暂未开放`})
      return false
    }
    // 获取中间token
    const { code, data } = await axios.get(`/api.php?m=common&a=maintain&responsetype=crm`)
    if(code == 200) {
        let str = data?.str
        let jumpUrl = url.replace("<loginStr>", str)

        if(path){
          const pathStr = encodeURIComponent(path)
          jumpUrl+=`&jumpPath=${pathStr}`
        }
        window.open(jumpUrl)
    }
  },
   // 导出excel
  //手动导出 参数
  exportData(options){
      //  options = {
      //         filename :`导出表.xlsx`,
      //         sheetName: 'Sheet1',// 分页名称
      //         // 导出excel的表头
      //         tHeader: ['姓名', '项目归属', '日期', '上班打卡时间', '下班打卡时间', '餐补金额', '车补金额'],
      //         // filterVal 与中文表头对应对象属性名称
      //         filterVal: ['uname','xmz', 'sdt', 'begin_dksj', 'end_dksj', 'canbu_money', 'chebu_money'],
      //         // 数据
      //         list: tableData
      //};
      function formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      }
      const workbook = XLSX.utils.book_new();
      const formattedData = formatJson(options.filterVal, options.list);
      const worksheetData = [options.tHeader, ...formattedData]; // 添加标题行和数据行
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData); // 创建工作表
      XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName) // 将工作表添加到工作簿
      XLSX.writeFile(workbook, options.filename); // 导出Excel文件
  },
  // 通过新标签页打开路由
  openNewTab(route){
    let { href } = router.resolve(route)
    window.open(href, '_blank')
  },
  formatValue(value, type) {
    if (type == 'rate') {
      if (isNaN(+(value))) {
        return '-'
      }
      return (+(value) * 100).toFixed(1) + '%'
    } else if (type == 'time:m-s') { //value是秒，转为x分x秒的字符串
      if (isNaN(+(value))) {
        return '-'
      }
      let m = Math.floor(value / 60)
      let s = value % 60
      return `${m>0?`${m}分`:''}${s || '-'}秒`
    } else if (type == 'range') {
      let [start, end] = value?.split('~') || []
      if (isNaN(+(start)) || isNaN(+(end))) {
        return '0'
      }
      start = start >= 10000 ? start / 10000 + 'w' : start
      end = end >= 10000 ? end / 10000 + 'w' : end
      return `${start}~${end}`
    } else if (type == 'w') {
      if (isNaN(+(value))) {
        return '-'
      }
      return (+value) >= 10000 ? (+value) / 10000 + 'w' : (+value).toLocaleString() || 0
    } else {
      if (isNaN(+(value))) {
        return '-'
      }
      return (+value).toLocaleString() || 0
    }
  },
}
// 获取滚动条宽度
export function getScrollbarWidth() {
  // 创建一个div，设置样式模拟滚动条
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
// 获取接口缓存数据，cacheKey 缓存的key，apiFn 函数，返回接口返回值，refresh 强制刷新
export async function apiCache(cacheKey, apiFn = ()=>{}, refresh = false){
  let data = window.sessionStorage.getItem(cacheKey)
  if (data && refresh == false) {
    return JSON.parse(data)
  } else {
    const res = await apiFn()
    if (res) {
      window.sessionStorage.setItem(cacheKey,JSON.stringify(res))
    }
    return res
  }
}

/**
 *  41452 -> '41,452.00'
 *  9897.25 -> '9,897.25'
 * @param {number} num
 * @param {number} decimal
 * @return {string}
 */
function fmtNumForMillage(num, decimal = 2) {
  if(isNaN(Number(num))) return num
  let result = Number(num).toFixed(decimal)
  let str = (+result).toLocaleString()
  let cur = str.split('.')[1]
  let dec0 = Array(decimal).fill(0).join('')
  let r = `${cur || ''}${dec0}`
  return `${str.split('.')[0]}.${r.slice(0, decimal)}`
}

Vue.prototype.fmtNumForMillage = fmtNumForMillage